import { h, Fragment } from "preact";
import ProductOptionSwatchesGrouped from "./product-option-swatches-grouped";
import ProductOptionSwatches from "./product-option-swatches";
import ProductOptionPills from "./product-option-pills";
import ProductOptionPillsInline from "./product-option-pills-inline";
import ProductOptionSwatchesInline from "./product-option-swatches-inline";

export default function ProductOption({
  option,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues,
  allowMaterialGroups,
  selectedIsHidden,
  selectedVariant,
  openByDefault,
  last,
  enableSwatchPreview,
  enableAccordions,
}) {
  const isSwatch = option.optionValues.some(
    (optionValue) => optionValue.swatch,
  );

  const showMaterialGroups =
    allowMaterialGroups &&
    option.optionValues.some((optionValue) => optionValue.materialGroup);

  const optionValues = option.optionValues.filter((optionValue) => {
    if (selectedIsHidden) {
      return optionValue.name === selectedOptionValue;
    }

    return !optionValue.allMatchingVariantsHidden;
  });

  if (enableAccordions) {
    if (isSwatch) {
      if (showMaterialGroups) {
        return (
          <ProductOptionSwatchesGrouped
            optionValues={optionValues}
            optionName={option.optionName}
            updateOptionValue={updateOptionValue}
            selectedOptionValue={selectedOptionValue}
            disabledOptionValues={disabledOptionValues}
            selectedVariant={selectedVariant}
            openByDefault={openByDefault}
            last={last}
            enableSwatchPreview={enableSwatchPreview}
          />
        );
      } else {
        return (
          <ProductOptionSwatches
            optionValues={optionValues}
            optionName={option.optionName}
            updateOptionValue={updateOptionValue}
            selectedOptionValue={selectedOptionValue}
            disabledOptionValues={disabledOptionValues}
            selectedVariant={selectedVariant}
            openByDefault={openByDefault}
            last={last}
            enableSwatchPreview={enableSwatchPreview}
          />
        );
      }
    }

    return (
      <ProductOptionPills
        optionValues={optionValues}
        optionName={option.optionName}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
        openByDefault={openByDefault}
        last={last}
      />
    );
  } else {
    if (isSwatch) {
      return (
        <ProductOptionSwatchesInline
          optionValues={optionValues}
          optionName={option.optionName}
          updateOptionValue={updateOptionValue}
          selectedOptionValue={selectedOptionValue}
          disabledOptionValues={disabledOptionValues}
          last={last}
        />
      );
    }

    return (
      <ProductOptionPillsInline
        optionValues={optionValues}
        optionName={option.optionName}
        updateOptionValue={updateOptionValue}
        selectedOptionValue={selectedOptionValue}
        disabledOptionValues={disabledOptionValues}
        last={last}
      />
    );
  }
}
